import React from "react";
import "./loading.scss";

const MeLoading = props => (
  <div className="all">
    <svg id="icon-load-play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.27 162.93">
      <title>icon-load-play</title>
      <path
        className="me-loading-book"
        d="M94.12,13.19a3.46,3.46,0,0,0-3.55-.49L33.83,37.27a22.3,22.3,0,0,1-8.73,1.59,31.81,31.81,0,0,1-12.18-2.42,14.67,14.67,0,0,1-2.77-1.53c.25-.12.53-.24.86-.37L62.62,12.2l7.71,3.29V5.87a4.54,4.54,0,0,0-1.65-3.6,3.46,3.46,0,0,0-3.55-.48L8.34,26.35a13.3,13.3,0,0,0-4.53,2.84A7.83,7.83,0,0,0,1.5,34.67V121.6h0a8.63,8.63,0,0,0,3.1,6.31c4.1,3.61,10.69,5.79,17.88,6.34v23.91L42,130.24l1.58-.67,49.66-21.92a4.29,4.29,0,0,0,2.48-4V16.81A4.58,4.58,0,0,0,94.12,13.19Z"
      />
      <path
        className="me-loading-play"
        d="M76.94,73.08,54,59.69a.47.47,0,0,0-.7.4V94.51a.47.47,0,0,0,.78.34L77,73.82A.46.46,0,0,0,76.94,73.08Z"
      />
    </svg>
  </div>
);

export default MeLoading;
